import LinkButton from 'components/shared/button/LinkButton';
import GNEModal from 'components/shared/modal/Modal';
import {
  areas,
  BOOLEAN_FALSE,
  CONFIGURE_VIEW,
  EMPTY_ARRAY,
  NUMBER_ZERO,
} from 'constants/constants';
import { Button, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteInsightView } from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setSelectedInsightView,
  setCards,
} from 'store/customer/customerViewSlice';
import { setAllMView } from 'store/home/homeMyViewSlice';
import { deleteUserView } from '../services/user-view.service';
import classes from './ViewActions.module.scss';
import { flushSync } from 'react-dom';
import { usePromiseTracker } from 'react-promise-tracker';

const DeleteViewModal = ({
  openModal,
  setOpenModal,
  currentViewRecord,
  page,
  custInsightsBrdId,
}) => {
  const dispatch = useDispatch();
  const allMViews = useSelector((state) => state?.HomeMyView?.allMViews);
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const isMyView = page === CONFIGURE_VIEW.myView;
  const isInsights = page === CONFIGURE_VIEW.insights;
  const { promiseInProgress: deleteViewStatus } = usePromiseTracker({
    area: areas.deleteCardsThenView,
  });

  const handleCloseModal = () => {
    setOpenModal((pre) => ({ ...pre, isDelete: BOOLEAN_FALSE }));
  };

  const handleDeleteView = async () => {
    if (isMyView) {
      const isViewDeleted = await deleteUserView(currentViewRecord.Id);
      if (isViewDeleted) {
        const updatedViewRecord = allMViews.filter(
          (item) => item.Id !== currentViewRecord.Id
        );
        dispatch(setAllMView(updatedViewRecord));
        setOpenModal((pre) => ({ ...pre, isDelete: BOOLEAN_FALSE }));
        toast.success('The view has been successfully deleted.');
      }
    } else if (isInsights) {
      const isViewDeleted = await deleteInsightView(
        currentViewRecord.Id,
        custInsightsBrdId
      );
      if (isViewDeleted) {
        const updatedViewRecord = allInsightViews.filter(
          (item) => item.Id !== currentViewRecord.Id
        );
        dispatch(setAllInsightView(updatedViewRecord));
        dispatch(
          setSelectedInsightView(
            updatedViewRecord?.length > NUMBER_ZERO
              ? updatedViewRecord[NUMBER_ZERO]
              : null
          )
        );
        flushSync(() => {
          setOpenModal((pre) => ({ ...pre, isDelete: BOOLEAN_FALSE }));
        });
        dispatch(setCards(EMPTY_ARRAY));
        toast.success('The view has been successfully deleted.');
      }
    }
  };

  const content = (
    <div className={classes['content-container']}>
      <div className='d-flex align-items-center'>
        <i className={'icon icon__remove-black lg'}></i>
        <span className='title__medium title__bold mt-1 ml-1 my-1'>
          Delete View
        </span>
      </div>
      <div className='text text__small pt-1'>
        {`The following view will be deleted from ${
          isInsights ? 'this insight board' : 'My View'
        }. Do you want to proceed?`}
      </div>
      <div className='mt-4'>
        <Form.Group
          as={Col}
          controlId='validationCustom01'>
          <Form.Control
            type='text'
            value={currentViewRecord?.name}
            readOnly
            className={`text text__normal border border-danger `}
          />
        </Form.Group>
      </div>
      <div className={`d-flex justify-content-end ${classes['content-foot']}`}>
        <LinkButton
          className='text text__small'
          onClick={handleCloseModal}>
          Cancel
        </LinkButton>

        <Button
          variant='btn btn-gne btn-primary'
          onClick={handleDeleteView}
          disabled={deleteViewStatus}
          className={`text__small ms-3 ${classes['save-btn']}`}>
          Yes
        </Button>
      </div>
    </div>
  );

  return (
    <GNEModal
      show={openModal}
      onHide={handleCloseModal}
      content={content}
      css='size-medium'
    />
  );
};

export default DeleteViewModal;
